/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { compose } from 'recompose';
import DesktopMobile from '../../../../../../helpers/DesktopMobile/DesktopMobile';
import ResultPage from './ResultPage';
import LandingPage from './LandingPage';
import { trackPage } from '../../../../../../helpers/tracking/common/commonTrackingHelpers';
import GraphqlSeoHeadTags from '../../../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import withPageView from '../../../../../../helpers/tracking/hocs/withPageView';
import { trackEvent as track } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const useStyles = () =>
    makeStyles({
        contentContainer: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            minHeight: 'calc(110vh - 236px)',
            justifyContent: 'space-between',
            flexDirection: 'column',
            zIndex: '2',
            height: '100%',
            width: '100%',
            paddingBottom: '18px',
        },
        underlay: {
            position: 'absolute',
            width: '100vw',
            height: '100%',
            zIndex: '-1',
            background: 'linear-gradient(0deg, #dffaff 0%, #117B91 100%)',
        },
        underlayPoemResultsPage: {
            position: 'absolute',
            width: '100vw',
            height: '100%',
            zIndex: '-1',
            background: 'linear-gradient(0deg, #dffaff 0%, #117B91 100%)',
        },
    });

const FloraVerse = ({trackEvent, ...props }) => {
    const options = {
        writeA: '', // verseType
        forMy: '', // recipient
        verseOccasion:'', // occassion
        whoLikes: { optionA: '', optionB: '', optionC: '' }, // who likes
    };
    const [poemStack, setPoemStack] = useState([]);
    const [poem, setPoem] = useState('');
    const [recipient, setRecipient] = useState('');
    const [selections, setSelections] = useState(options);
    const [error, setError] = useState('');

    const interestsEventLabel =`${selections.whoLikes.optionA}|${selections.whoLikes.optionB}|${selections.whoLikes.optionC}`;

    const fireTrackEventByType = (type) => {
        switch (type) {
            case 'SUCCESS':
                trackEvent({
                    eventCategory: occasion,
                    eventAction: 'Output',
                    eventLabel: selections.writeA,
                });
                trackEvent({
                    eventCategory: occasion,
                    eventAction: 'Whom',
                    eventLabel: selections.forMy,
                });
                trackEvent({
                    eventCategory: occasion,
                    eventAction: 'Interests',
                    eventLabel: interestsEventLabel,
                });
                break;
            case 'FAILURE_INAPPROPRIATE':
                trackEvent({
                    eventCategory: occasion,
                    eventAction: 'Inappropriate interests',
                    eventLabel: interestsEventLabel,
                });
                break;
            case 'FAILURE_UNSPECIFIED':
                trackEvent({
                    eventCategory: occasion,
                    eventAction: 'Error',
                    eventLabel: 'General error - no poem generated',
                });
                break;
            default:
                break;
        }
    };

    const handlePoemMutationSuccess = (poem, isSuccessful, callback = null) => {
        if (/^inappropriate|malicious|invalid|No poem generated/gi.test(poem)) {
            fireTrackEventByType('FAILURE_INAPPROPRIATE');
            setError('A verse cannot be composed based on the input. Please try again with alternative inputs.');
        } else if (isSuccessful) {
            const updatePoem = {
                poem,
                target: selections?.forMy ?? '',
                targetVerseOccasion: selections?.verseOccasion ?? '',
            };

            fireTrackEventByType('SUCCESS');
            setPoemStack((prev) => [...prev, updatePoem]);
            setPoem(poem || '');

            if (callback) callback();
        } else {
            fireTrackEventByType('FAILURE_UNSPECIFIED');
            setError('An error has occurred. Please try again.');
        }
    };

    const handlePoemMutationError = () => {
        fireTrackEventByType('FAILURE_UNSPECIFIED');
        setError('An error has occurred. Please try again.');
    };

    const classesLayout = useStyles();
    const classes = classesLayout();
    const occasion = props.page.type;

    const handleSetPreviousPoemMomVerse = () => {
        const poems = poemStack.slice(0, -1);
        const { poem = '', target = ''} = poems?.[poems.length - 1] || {};
        setPoemStack(poems);
        setPoem(poem);
        setRecipient(target);
    };

    const handleResetPoem = () => {
        setPoem('');
        setRecipient('');
        setSelections(options);
    };


    const getSeoDataByBrand = () => {
        const seoData = {
            page_title: '',
            meta_description:
                "Our AI powered composer can help you create a personalized poem, haiku, & more! The perfect addition to your gift!",
            canonicalUrl: 'https://www.1800flowers.com/account/floraverse',
        };
            switch (props.brandId) {
                case '18F':
                    seoData.page_title = "Create Poems and More with FloraVerse | 1800Flowers";
                    seoData.meta_description =
                        "Welcome to the 1800Flowers FloraVerse. Use our AI powered poetry composer to create a personalized poem , haiku, and more for someone you care about!";
                    break;
                case '18B':
                    seoData.page_title = "Write Poems & More with FloraVerse | 1800Baskets";
                    break;
                case 'SCH':
                    seoData.page_title = "Write Poems with FloraVerse | Simply Chocolate";
                    break;
                case 'BRY':
                    seoData.page_title = "Write Poems & More with FloraVerse | Shari's Berries";
                    break;
                case 'FB':
                    seoData.page_title = "Send Poems & More with FloraVerse | Fruit Bouquets";
                    break;
                case 'HD':
                    seoData.page_title = "Write Poems & More with FloraVerse | Harry & David";
                    break;
                case 'WLF':
                    seoData.page_title = "Send Poems & More with FloraVerse | Wolferman's";
                    break;
                case 'SY':
                    seoData.page_title = "Write Poems & More with FloraVerse | Stockyards";
                    break;
                case 'VC':
                    seoData.page_title = "Write Poems & More with FloraVerse | Vital Choice";
                    break;
                case 'CCO':
                    seoData.page_title = "Write Poems & More with FloraVerse | Cheryl's";
                    break;
                case 'TPF':
                    seoData.page_title = "Send Poems with FloraVerse | The Popcorn Factory";
                    break;
                default:
                    break;
            }
        return seoData;
    };

    return (
        <>
            <Helmet>
                <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Dosis" crossOrigin="anonymous" />
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
                <link href="https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap" rel="stylesheet" />
            </Helmet>
            <GraphqlSeoHeadTags seoData={getSeoDataByBrand()} />
            <div className={classes.contentContainer}>
                {poem ? (
                    <DesktopMobile
                        desktop={() => (
                            <ResultPage
                                setRecipient={setRecipient}
                                recipient={recipient}
                                previousMomVerseEnabled={poemStack.length > 1}
                                handleSetPreviousPoemMomVerse={handleSetPreviousPoemMomVerse}
                                handleResetPoem={handleResetPoem}
                                poem={poem}
                                occasion={occasion}
                                handlePoemMutationSuccess={handlePoemMutationSuccess}
                                handlePoemMutationError={handlePoemMutationError}
                                selections={selections}
                                error={error}
                                setError={setError}
                            />
                        )}
                        mobile={() => (
                            <ResultPage
                                setRecipient={setRecipient}
                                recipient={recipient}
                                previousMomVerseEnabled={poemStack.length > 1}
                                handleSetPreviousPoemMomVerse={handleSetPreviousPoemMomVerse}
                                handleResetPoem={handleResetPoem}
                                poem={poem}
                                mobile
                                occasion={occasion}
                                handlePoemMutationSuccess={handlePoemMutationSuccess}
                                handlePoemMutationError={handlePoemMutationError}
                                selections={selections}
                                error={error}
                                setError={setError}
                            />
                        )}
                    />
                ) : (
                    <DesktopMobile
                        desktop={() => (
                            <LandingPage
                                setRecipient={setRecipient}
                                occasion={occasion}
                                handlePoemMutationSuccess={handlePoemMutationSuccess}
                                handlePoemMutationError={handlePoemMutationError}
                                selections={selections}
                                setSelections={setSelections}
                                options={options}
                                error={error}
                                setError={setError}
                            />
                        )}
                        mobile={() => (
                            <LandingPage
                                setRecipient={setRecipient}
                                mobile
                                occasion={occasion}
                                handlePoemMutationSuccess={handlePoemMutationSuccess}
                                handlePoemMutationError={handlePoemMutationError}
                                selections={selections}
                                setSelections={setSelections}
                                options={options}
                                error={error}
                                setError={setError}
                            />
                        )}
                    />
                )}
                {poem && <div className={classes.underlayPoemResultsPage} />}
                {!poem && <div className={classes.underlay} />}
            </div>
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

const enhance = compose(
    trackPage({
        type: 'floraverse',
        name: 'floraverse page',
        accountPage: true,
    }),
    withPageView({
        pageViewSuccessTest: () => true,
    }),
    connect(null, mapDispatchToProps)
);

export default enhance(FloraVerse);
